"use strict";

Core.Invite = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/invite',

    claim: function() {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/claim',
            type: 'PUT',
        }).success(function (data) {
            self.set(data);
        });
    },

    accept: function() {
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/accept',
            type: 'PUT'
        });
    },

    resend: function() {
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/resend',
            type: 'POST'
        });
    },


});

Core.Invites = Backbone.Collection.extend({
    model: Core.Invite,
    url: function() { return Core.contextRoot + '/invite' + (this.path ? '/' + this.path : ''); },
    initialize: function(models, options) { if (options && options.path) this.path = options.path; },
});

